<template>
  <v-dialog v-model="open" max-width="900px">
    <v-card>
      <v-toolbar dense color="primary" dark>
        Report Issue
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form ref="reportIssueForm">
          <v-layout row wrap>
            <v-flex
              :xs12="formData.issueType != 'Other'"
              :xs6="formData.issueType == 'Other'"
              class="px-2"
            >
              <v-select
                label="Issue Type"
                v-model="formData.issueType"
                :items="reportOptions"
                item-text="text"
                item-value="value"
                :rules="[(v) => !!v || 'Please select an issue type']"
              ></v-select>
            </v-flex>
            <v-flex xs6 v-if="formData.issueType == 'Other'" class="px-2">
              <v-text-field
                label="Other"
                v-model="formData.otherIssue"
                :rules="textFieldRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                label="Message"
                v-model="formData.message"
                rows="7"
                :rules="textFieldRules"
              >
              </v-textarea>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" @click="toggleDialog()" dark>Cancel</v-btn>
        <v-btn color="success" @click="send" :loading="emailSending"
          >Send</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    emailSending: false,
    formData: {},
    open: false,
    reportOptions: [
      { text: "Issue with enquiry", value: "Issue with enquiry" },
      { text: "Accidental enquiry", value: "Accidental enquiry" },
      { text: "Wrong customer", value: "Wrong customer" },
      { text: "Other", value: "Other" },
    ],
    textFieldRules: [(v) => !!v || "This cannot be empty"],
  }),
  methods: {
    send() {
      if (this.$refs.reportIssueForm.validate()) {
        this.emailSending = true;
        this.$store
          .dispatch("emailSending/sendReportIssue", this.formData)
          .then(() => {
            this.emailSending = false;
          });
      }
    },
    toggleDialog() {
      this.open = !this.open;
    },
  },
};
</script>
